<template>
  <a-row type="flex" justify="space-between">
    <a-col :span="10" :offset="7">
      <a-form layout="vertical" :form="formVarm" @submit="iniciarSesion">
        <h1 class="titulo" style="font-weight: bold; font-size: 16px; margin-bottom: 20px">
          InfoCasas - Emails
        </h1>
        <a-form-item>
          <span slot="label">
            Nombre Usuario
          </span>
          <a-input v-decorator="[
            'username',
            {
              rules: [
                {
                  required: true,
                  message: 'Ingrese el usuario',
                },
              ],
            },
          ]" class="shadowInputs" />
        </a-form-item>

        <a-form-item>
          <span slot="label">
            Contraseña
          </span>
          <a-input type="password" v-decorator="[
            'password',
            {
              rules: [
                {
                  required: true,
                  message: 'Ingrese su contraseña',
                },
              ],
            },
          ]" class="shadowInputs" />
        </a-form-item>

        <a-form-item>
          <a-row type="flex" justify="center" align="middle" :gutter="20">
            <a-col><a-button type="primary" html-type="submit" size="large">Iniciar Sesión</a-button></a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-col>
  </a-row>

</template>

<script>
import utils from '../service/service.js'
export default {
  name: "Login",
  props: {},
  mixins: [utils],
  data() {
    return {
      formVarm: this.$form.createForm(this),
    };
  },
  methods: {
    async iniciarSesion(e) {
      e.preventDefault();
      this.formVarm.validateFields(async (err) => {
        if (err !== null) { return false; }
        const $this = this;
        const dataForm = this.formVarm.getFieldsValue();
        const { status, message, data } = await this.sendRequest({
          method: 'POST',
          url: 'users/login',
          data: dataForm,
        })
        if (status) {
          localStorage.setItem("md5", JSON.stringify(data.token));
          localStorage.setItem("rol", JSON.stringify(data.rol));
          localStorage.setItem("username", JSON.stringify(data.username));
          localStorage.setItem("company", JSON.stringify(data.company));
          this.$swal({
            icon: "success",
            title: "¡Bienvenido de vuelta!",
            text: message,
          });
          setTimeout(function () {
            $this.$router.go();
          }, 1200);
        } else {
          this.$swal({
            icon: "warning",
            title: "¡Lo sentimos!",
            text: message,
          });
        }
      })
    },
  },
};
</script>

<style>
.submit-form {
  max-width: 300px;
  margin: auto;
}
</style>
